import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createSlots as _createSlots, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onBeforeMount, ref } from 'vue'

import type { DocView } from '@/models/doc'
import { HeaderView } from '@/models/header'
import { saveForLater20321Treatment } from '@/services/ab/experiments'

import HeaderAppDesktop from '@/app/components/header/AppDesktop.vue'
import HeaderInternal from '@/app/components/header/Internal.vue'
import DocMoreMenu from '@/app/components/doc/DocMoreMenu.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Header',
  props: {
    doc: {}
  },
  setup(__props: any) {

const props = __props

const view = ref(new HeaderView(props.doc))

// On mobile, the "more" menu is here instead of the sidebar.
const showNewSaveDesign = saveForLater20321Treatment()

onBeforeMount(async () => {
  await view.value.init()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeaderAppDesktop, {
      class: _normalizeClass(view.value.headerClass)
    }, null, 8, ["class"]),
    _createVNode(HeaderInternal, {
      title: __props.doc.title,
      backLinkDoc: __props.doc,
      class: _normalizeClass(["header--scroll header--book", view.value.headerClass])
    }, _createSlots({ _: 2 }, [
      (_unref(showNewSaveDesign))
        ? {
            name: "actions",
            fn: _withCtx(() => [
              _createVNode(DocMoreMenu, { doc: __props.doc }, null, 8, ["doc"])
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["title", "backLinkDoc", "class"])
  ], 64))
}
}

})